import { render, staticRenderFns } from "./cfsFileTableLList.vue?vue&type=template&id=236f85ba&scoped=true"
import script from "./cfsFileTableLList.vue?vue&type=script&lang=js"
export * from "./cfsFileTableLList.vue?vue&type=script&lang=js"
import style0 from "./cfsFileTableLList.vue?vue&type=style&index=0&id=236f85ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f85ba",
  null
  
)

export default component.exports